import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { OrderFulfillmentBadge } from "../../../components/badge/OrderFulfillmentBadge";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { getOrderFulfillmentBadgeType } from "../../../utils/getOrderFulfillmentBadgeType";

export default function OrderFulfillmentIndicator({
  fulfillmentType,
}: {
  fulfillmentType: OrderGetResponseType["fulfillmentType"] | null;
}) {
  const { business } = useSellarCurrentBusiness();
  return (
    <OrderFulfillmentBadge
      type={getOrderFulfillmentBadgeType({
        fulfillmentType,
        isSupplier: !!business?.Supplier,
      })}
    />
  );
}
